import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from '@app/shared/constants';
import { environment } from '@env/environment';
import { Business } from '../../models/Business';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private httpClient: HttpClient) { }
  updateAccount(payload: Business) {
    return this.httpClient.post(environment.baseUrl + AppConstant.UPDATE_ACCOUNT_SETTING,payload);
  }
  getBusinessDetails(userId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.GET_BUSINESS_DETAILS + userId);
  }
}
